import { moyrToAnnual } from "src/utils";
import { adjustForInflation, adjustForIncrease, isDead } from "./utils";
import { CalculationInfo } from "./types";
import { BasicAnnuity } from "src/types";
import { startEndToYear } from "src/components/Info/StartEndSelect";

export const calculate = (info: CalculationInfo<BasicAnnuity>) => {
  const { income, currentYear } = info;
  const startYear = new Date().getFullYear();
  const start = startEndToYear(info.income.start, info.people, info.scenario);
  let amount = 0;
  if (income.amountType === "Schedule") {
    //lookup in startAmounts
    let i = start - startYear;
    while (i > 0) {
      if (income.startAmounts[i]) {
        amount = income.startAmounts[i];
        if (income.scheduleMoYr === "monthly") {
          amount = amount * 12;
        }
        break;
      }
      i--;
    }
  } else {
    amount = income.amount ? moyrToAnnual(income.amount) : income.annualAmount;
  }
  let yearAmount = adjustForIncrease(info, amount, start);

  if (currentYear < start) {
    return 0;
  }

  yearAmount = adjustForInflation(info, yearAmount, startYear);

  if (isDead(info, income.personId)) {
    return (yearAmount * income.survivorPercent) / 100;
  }
  if (currentYear == start) {
    return (yearAmount * income.firstYearProRatePercent) / 100;
  }

  return yearAmount;
};

export const calculateBasicAnnuity = (info: CalculationInfo<BasicAnnuity>) => {
  return { amount: calculate(info), note: "" };
};
